import { transformRoutes } from '@backoffice-frontend/common'

export const BaseUserManagementOrganizationAreaRoutes = {
  route: '/organization-management',
  User: {
    route: '/user',
    Show: {
      route: '/:id',
      History: {
        route: '/history',
      },
    },
  },
  Users: {
    route: '/users',
  },
  Group: {
    route: '/group',
    Show: {
      route: '/:groupName',
      Users: {
        route: '/users',
      },
      Rights: {
        route: '/rights',
      },
      History: {
        route: '/history',
      },
    },
  },
  Groups: {
    route: '/groups',
  },
  History: {
    route: '/history',
  },
}

export const UserManagementOrganizationAreaRoutes = transformRoutes(
  BaseUserManagementOrganizationAreaRoutes,
)
